import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

export default function MetaOAuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const errorParam = searchParams.get("error");

    if (errorParam) {
      setError(`Facebook denied access: ${searchParams.get("error_description") || errorParam}`);
      return;
    }
    if (!code || !state) {
      setError("Missing authorization code from Facebook.");
      return;
    }

    api.get("/integrations/meta/oauth/callback", { params: { code, state } })
      .then((res) => {
        const pages = res.data.connected_pages || [];
        toast.success(`Connected ${pages.length} Facebook Page(s) successfully!`);
        navigate("/integrations", { replace: true });
      })
      .catch((err) => {
        const detail = err.response?.data?.detail || "Failed to connect Facebook";
        setError(detail);
      });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-cream">
        <div className="max-w-md rounded-xl border border-red-200 bg-white p-8 text-center shadow">
          <p className="text-lg font-semibold text-red-700">Connection Failed</p>
          <p className="mt-2 text-sm text-muted-foreground">{error}</p>
          <button
            onClick={() => navigate("/integrations")}
            className="mt-4 rounded-lg bg-navy px-4 py-2 text-sm text-white hover:bg-navy-hover"
          >
            Back to Integrations
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream">
      <div className="text-center">
        <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-navy border-t-transparent" />
        <p className="mt-4 text-sm text-muted-foreground">Connecting your Facebook Pages...</p>
      </div>
    </div>
  );
}
